import React, { Component } from "react";
import { injectIntl } from "react-intl";

// HOC
import AppHOC from "../hoc/AppHOC";

import { connect } from "react-redux";
import ModalPortal from "../components/modals/ModalPortal";
import ErrorPopup from "../components/popups/ErrorPopup";
import renderLangString from "../languageStrings";

export const GenericError = props => {
  if (!props.app.errorPopup) {
    return null;
  }

  return (
    <ModalPortal>
      <ErrorPopup
        title={renderLangString({ id: "$_b1" })}
        text={renderLangString({ id: "$_b2" })}
        iconId="infoFull"
        reloadPageBtn
      />
    </ModalPortal>
  );
};

const mapStateToProps = state => ({
  app: state.app,
});

export default injectIntl(connect(mapStateToProps)(GenericError));
